import { createSlice } from "@reduxjs/toolkit";
import { SettingsState } from "./types";
import { fetchApiKey, fetchUserIntegration } from "./settings-thunk";
import { ErrorType } from "@/shared/types";

const initialState: SettingsState = {
    apiKey: null,
    isApiKeyLoading: false,
    isApiKeyFirstLoad: true,
    apiKeyError: null,
    userIntegration: null,
    userIntegrationError: null,
    isUserIntegrationLoading: false,
    isUserIntegrationFirstLoad: true
}

const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
        .addCase(fetchApiKey.pending, (state) => {
            state.isApiKeyLoading = true
            state.apiKeyError = null
        })
        .addCase(fetchApiKey.fulfilled, (state, action) => {
            state.isApiKeyFirstLoad = false
            state.isApiKeyLoading = false
            state.apiKey = action.payload
            state.apiKeyError = null
        })
        .addCase(fetchApiKey.rejected, (state, action) => {
            state.apiKeyError = action.payload as ErrorType
            state.isApiKeyLoading = false
        })
        .addCase(fetchUserIntegration.pending, (state) => {
            state.isUserIntegrationLoading = true
            state.userIntegrationError = null
        })
        .addCase(fetchUserIntegration.fulfilled, (state, action) => {
            state.isUserIntegrationFirstLoad = false
            state.isUserIntegrationLoading = false
            state.userIntegration = action.payload
            state.userIntegrationError = null
        })
        .addCase(fetchUserIntegration.rejected, (state, action) => {
            state.userIntegrationError = action.payload as ErrorType
            state.isUserIntegrationLoading = false
            state.userIntegration = null
        })
    },
})

export default settingsSlice.reducer
export const {} = settingsSlice.actions